import { Title } from 'src/components/atoms/styled/element';
import FormModal from 'src/components/organisms/FormModal';
import styled from 'styled-components';

export const CompanyInfoUpdateModalWrapper = styled(FormModal)`
  & .modal-body {
    & > ${Title} {
      margin: 20px 0;

      border-bottom: 1px solid #d8dbe0;

      width: 100%;

      font-size: 20px;
    }

    & > div.row {
      margin-bottom: 16px;
    }
  }
`;
